import React, { useState, useEffect } from "react";
import Menu from "../../../../components/layout/menu/index";
import FilterInput from "../../../../components/filters/filterInput";
import '../../../../../src/index.css'
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ATCFilters from "../../../../components/filters/atcFilters";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import { getTableConfig } from "../../../../components/tables/atc/tableColumns";
import { useModuleAdherence } from "../../../../hooks/userAdherence";
import { useAuth } from "../../../../context/auth";
import ResetFilters from "../../../../components/filters/resetFilters";
import DetailATC from "../../../../components/shared/modals/atc/detailAtc";
import { getListAtc, observeAtc } from "../../../../client/atc";
import AtcObs from "../../../../components/shared/modals/atc/atcObs";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
const statusIdToNameMapping = {
  13: 'Vacío',
  9: 'Observado',
  15: 'Cancelado',
  14: 'Rech.2da.aprob.',
  18: 'Rech.1ra.aprob.',
  16: 'Pend.1ra.aprob.',
  17: 'Pend.2da.aprob.',
  4: 'Aprobado'
};

const statusColors = {
  'Vacío': '#00A3E0',
  'Observado': '#E44949',
  'Observados': '#E44949', 
  'Cancelado': '#E44949',
  'Rech.2da.aprob.': '#E44949',
  'Rech.1ra.aprob.': '#E44949',
  'Pend.2da.aprob.': '#FFB81C',
  'Pend.1ra.aprob.': '#FFB81C',
  'Aprobado': '#43B02A',
};

const liberationStatusColors = {
  'Liberado': '#43B02A',
  'No Liberado': '#E44949'
};

const generalStatusColors = {
'Pendiente de Llenado de ATC' : '#E44949',
'Pendiente de Creacion de OC' : '#00A3E0',
'Pendiente de Liberacion de Solped' : '#00A3E0',
'Pendiente de Liberacion de OC'  : '#00A3E0',
'Pendiente de HES'       : '#00A3E0',
'Pendiente de Facturación'      : '#FF6900',
'Cerrado / Culminado'       : '#00A3E0',
'Pendiente de Aprobación de ATC'    : '#00A3E0',    
};


const getStatusName = (statusId, statusNameFromApi) => {
  if (statusId && statusIdToNameMapping[statusId]) {
    return statusIdToNameMapping[statusId];
  }
  return statusNameFromApi ;
};

const getStatusColor = (statusId, statusNameFromApi) => {
  const statusName = getStatusName(statusId, statusNameFromApi);
  return statusColors[statusName] ;
};

<style>
{`
.table-simplebar .simplebar-scrollbar {
background: #007696;
border-radius: 20px;
width: 5px;
}

.table-simplebar .simplebar-scrollbar:before {
background: #007696 !important;
}
`}
</style>

const tabToStatusIdsMapping = {
  'Pendiente de llenado de ATC': [13, 18, 14], // Vacío,Rech. 1ra aproba, Rech. 2da aproba
  'En proceso': [16, 17], // Pend. 1ra aproba, Pend. 2da aproba
  'Observadas por el proveedor': [9], // Observado
  'Todas': [13, 9, 14, 18, 16, 17, 4] // Todos menos Cancelado (15)
};



export default function ATCProvider() {
  useModuleAdherence(5);
  const { supplierId, supplierCode } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [activeTab, setActiveTab] = useState('Todas');
  const tabs = ['Todas', 'Pendiente de llenado de ATC', 'En proceso',  'Observadas por el proveedor'];

  const [loading,setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [searchTerm, setSearchTerm] = useState('');

  const [resetFiltersFlag, setResetFiltersFlag] = useState(false);
  const [isTabChanging, setIsTabChanging] = useState(false);

  const [tableData, setTableData] = useState([]);

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedATC, setSelectedATC] = useState(null);

  const [tempFilters, setTempFilters] = useState({
    emissionDateFrom: '',
    emissionDateTo: '',
    statusIds: null,
    solpedNumbers: [],
    atcNumbers: [],
    otNumbers: [],
    ocNumbers: [],
    centersList: [],
    statusGeneralIds: [],
  });

  const [activeFilters, setActiveFilters] = useState({
    emissionDateFrom: '',
    emissionDateTo: '',
    solpedNumbers: [],
    atcStatuses: null,
    atcNumbers: [],
    otNumbers: [],
    ocNumbers: [],
    centersList: [],
    statusGeneralIds: [],
  });

  const [selectedRows, setSelectedRows] = useState([]);
  const [allSelectedIds, setAllSelectedIds] = useState([]); 

  const [showRadioButtons, setShowRadioButtons] = useState(false);

const [isObsModalOpen, setIsObsModalOpen] = useState(false);
const [observingIds, setObservingIds] = useState([]);

const [showObsSuccessModal, setShowObsSuccessModal] = useState(false);
const [showObsErrorModal, setShowObsErrorModal] = useState(false);
const [obsModalMessage, setObsModalMessage] = useState('');
const [obsErrorModalMessage, setObsErrorModalMessage] = useState('');

  const [tabCounts, setTabCounts] = useState({
    'Pendiente de llenado de ATC': 5,
    'En proceso': 8,
    'Observadas por el proveedor': 2

  });

    useEffect(() => {
    if (!supplierId) {
      console.error('Proveedor no encontrado.');
    }
  }, [supplierId]);

  
const handleOpenDetails = (atcData) => {
  setSelectedATC(atcData);
  setIsDetailModalOpen(true);
};

const handleCloseDetails = () => {
  setIsDetailModalOpen(false);
  setSelectedATC(null);
};

const loadTableData = async () => {
  if (!supplierId) {
    console.warn('Proveedor no encontrado');
    return;
  }

  setIsTabChanging(true);
  setLoading(true);
  
  try {
    const statusIdsFilter = tabToStatusIdsMapping[activeTab];

    const emissionDateFrom = activeFilters.emissionDateFrom || undefined;
    const emissionDateTo = activeFilters.emissionDateTo || undefined;

    const response = await getListAtc(currentPage, recordsPerPage, {
      emissionDateFrom: emissionDateFrom,
      emissionDateTo: emissionDateTo,
      statusIds: statusIdsFilter,
      supplierIds: [supplierId], 
      searchAtcNumber: searchTerm || undefined,
      solpedNumbers: tempFilters.solpedNumbers?.length > 0 ? tempFilters.solpedNumbers : undefined, 
      atcNumbers: activeFilters.atcNumbers?.length > 0 ? activeFilters.atcNumbers : undefined, 
      otNumbers: activeFilters.otNumbers?.length > 0 ? activeFilters.otNumbers : undefined, 
      ocNumbers: activeFilters.ocNumbers?.length > 0 ? activeFilters.ocNumbers : undefined, 
      centers: activeFilters.centersList?.length > 0 ? activeFilters.centersList : undefined, 
      statusGeneralIds: activeFilters.statusGeneralIds?.length > 0 ? activeFilters.statusGeneralIds.map(id => parseInt(id)) : undefined,
      page: currentPage,
      pageSize: recordsPerPage
    });


    const transformedData = response.atcs.map((atc, index) => ({
      displayId: (currentPage - 1) * recordsPerPage + index + 1,
      id: atc.id,
      numeroATC: atc.atc_numero,
      centro: atc.centro,
      nroSolicitud: atc.solicitud_numero,
      otPos: atc.ot_pos,
      grafoOpe: atc.grafo_ope,
      solpedPOS: atc.solped_pos,
      ubiTecnica: atc.ubicacion_tecnica,
      resumenTrabajo: atc.atc_resumen,
      fechaCreacion: atc.fecha_creacion ? atc.fecha_creacion.split('T')[0] : '',
      estado: atc.lastStatus,
      estadoId: atc.lastStatusId,
      estadoColor: getStatusColor(atc.lastStatusId, atc.lastStatus), 
      nroSolped: atc.solped_numero,
      posSolped: atc.solped_pos,
      aprobador1: atc.aprobador_1,
      aprobador2: atc.aprobador_2,
      usuarioMaximo: atc.usuario_maximo,
      hesMax: atc.hesMax_numero,
      observacion: atc.atc_Observacion,
      estadoHes: atc.hesSap_liberado,
      estadoSolped: atc.solped_liberado,
      responsableHESSAP: atc.supervisor,
      posOC: atc.oc_posicion,
      estadoOC: atc.oc_liberado,
      oc: atc.oc_numero,
      responsableOc: Array.isArray(atc.oc_responsible) 
        ? atc.oc_responsible.join(', ') 
        : atc.oc_responsible || '',
      llenarATC: atc.atc_fecha_llenado ? atc.atc_fecha_llenado.split('T')[0] : '',
      detalles: () => handleOpenDetails(atc),
      fechaInicioTrabajo: atc.fecha_inicio_trabajo ? atc.fecha_inicio_trabajo.split('T')[0] : '',
      fechaFinTrabajo: atc.fecha_fin_trabajo ? atc.fecha_fin_trabajo.split('T')[0] : '',
      codServicio: atc.estado_cotizacion,
      motivoObservacion: atc.lastStatusReason,
      descripcionObservacion: atc.lastStatusObservation,

      getStatusColor: () => getStatusColor(atc.lastStatusId, atc.lastStatus),

      areaId: atc.areaId || null,

    
      fechaCreacionSolped: atc.solpedInfo?.position?.created_date,
      fechaLiberacionSolped: atc.solpedInfo?.position?.liberation_date,
      creado: atc.created,
      pendienteLiberacionSolped: atc.solpedInfo?.position?.pending_release,
      nroOT: atc.ot_numero,
      unidadNegocio: atc.unidad_negocio,
      estadoGeneralServicio: atc.status_general_description,

    }));

    setTableData(transformedData);
    setTotalRecords(response.totalCount);
    setTotalPages(response.totalPages);
    
    updateTabCounts(response.totalCount, activeTab);
    
  } catch (error) {
    console.error('Error loading ATC data:', error);
    setError('Error al cargar los datos');
  } finally {
    setLoading(false);
    setIsTabChanging(false);
  }
};

useEffect(() => {
  loadTableData();
}, [activeTab, currentPage, recordsPerPage, activeFilters, supplierId, searchTerm]);



const handleFilterChange = (filterTitle, value) => {
  const filterMap = {
    "Número de ATC:": "atcNumbers",
    "Número Solped:": "solpedNumbers",
    "Número de OT:": "otNumbers",
    "Número de OC:": "ocNumbers", 
    "Embarcación:": "centersList",
    "Estado general del servicio:": "statusGeneralIds", 
  };

  const filterKey = filterMap[filterTitle];
  if (filterKey) {
    setTempFilters(prev => ({
      ...prev,
      [filterKey]: value
    }));
  }
};

  const updateTabCounts = async (totalCount, currentTab) => {
    try {
      if (currentTab === 'Todas') {
        setTabCounts({
          'Pendiente de llenado de ATC': await getCountForTab('Pendiente de llenado de ATC'),
          'En proceso': await getCountForTab('En proceso'),
          'Observadas por el proveedor': await getCountForTab('Observadas por el proveedor')
        });
      }
    } catch (error) {
      console.error('Error updating tab counts:', error);
    }
  };

  const getCountForTab = async (tab) => {
    const statusIdsMapping = {
      'Pendiente de llenado de ATC': [13, 18, 14],
      'En proceso': [16, 17],
      'Observadas por el proveedor': [9]
    };

    try {
      const response = await getListAtc(1, 1, {
        emissionDateFrom: activeFilters.emissionDateFrom,
        emissionDateTo: activeFilters.emissionDateTo,
        atcStatuses: statusIdsMapping[tab],
        supplierIds: [supplierId],
        searchAtcNumber: searchTerm || undefined
      });
      
      return response.totalCount;
    } catch (error) {
      console.error(`Error getting count for ${tab}:`, error);
      return 0;
    }
  };

const handleSearchChange = (value) => {
  setSearchTerm(value);
  setCurrentPage(1); 
};


  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

const handleRecordsCountChange = (e) => {
  const newCount = Number(e.target.value);
  setRecordsPerPage(newCount);
  setCurrentPage(1); 
};

const changePage = (page) => {
  if (page < 1 || page > totalPages) return;
  setCurrentPage(page);
};



  const handleResetFilters = () => {
    setResetFiltersFlag(prev => !prev);
    setSearchTerm('');
    setCurrentPage(1);
    
    setActiveFilters({
      emissionDateFrom: '',
      emissionDateTo: '',
      solpedNumbers: [],
      atcStatuses: null,
      atcNumbers: [],
      otNumbers: [],
      ocNumbers: [],
      centersList: [],
     statusGeneralIds: [], 
    });
    setTempFilters({
      emissionDateFrom: '',
      emissionDateTo: '',
      statusIds: null,
      solpedNumbers: [],
      atcNumbers: [],
      otNumbers: [],
      ocNumbers: [],
      centersList: [],
      statusGeneralIds: [], 
    });
  };

const applyFilters = () => {
 
    const statusIdsFilter = tabToStatusIdsMapping[activeTab];
  
  setActiveFilters({ 
    ...tempFilters, 
    statusIds: statusIdsFilter,
    emissionDateFrom: tempFilters.emissionDateFrom,
    emissionDateTo: tempFilters.emissionDateTo,
    solpedNumbers: tempFilters.solpedNumbers || [],
    atcNumbers: tempFilters.atcNumbers || [],
    otNumbers: tempFilters.otNumbers || [],
    ocNumbers: tempFilters.ocNumbers || [],
    centersList: tempFilters.centersList || [],
    statusGeneralIds: tempFilters.statusGeneralIds || [], 
  });
  setCurrentPage(1);
};

const handleSelectClick = () => {
  const newShowRadioButtons = !showRadioButtons;
  setShowRadioButtons(newShowRadioButtons);
  
  if (!newShowRadioButtons) {
    setSelectedRows([]);
    setAllSelectedIds([]);
  } else {
    setSelectedRows(allSelectedIds);
  }
};

useEffect(() => {
  if (!showRadioButtons) {
    setSelectedRows([]);
  }
}, [showRadioButtons]);

useEffect(() => {
  setShowRadioButtons(false);
  setSelectedRows([]); 
}, [activeTab]);

const handleCheckboxChange = (id) => {
  setSelectedRows(prev => {
    const newSelected = prev.includes(id) 
      ? prev.filter(selectedId => selectedId !== id) 
      : [...prev, id];
    return newSelected;
  });
};

const handleObs = () => {
  if (selectedRows.length === 0) {
        setObsErrorModalMessage('Por favor, seleccione al menos un ATC para observar');
        setShowObsErrorModal(true);
    return;
  }
  
  setObservingIds([...selectedRows]); 
  setIsObsModalOpen(true); 
};

  const handleObsSubmit = async (data) => {
    try {

      if (observingIds.length === 0) {
        setObsErrorModalMessage('No hay ATCs seleccionados para observar.');
        setShowObsErrorModal(true);
        return;
      }

      if (!data.reason || !data.reason.trim()) {
        setObsErrorModalMessage('Por favor, seleccione un motivo.');
        setShowObsErrorModal(true);
        return;
      }

      if (!data.observation || !data.observation.trim()) {
        setObsErrorModalMessage('Por favor, ingrese una descripción.');
        setShowObsErrorModal(true);
        return;
      }

      const requestData = {
        recordIds: observingIds,
        reason: data.reason.trim(),
        observation: data.observation.trim()
      };
      
      
      setLoading(true);
      
      const response = await observeAtc(requestData);
      
      
      setObsModalMessage(response.message || `Observación enviada correctamente para ${observingIds.length} ATC(s)`);
      setShowObsSuccessModal(true);
      
      setIsObsModalOpen(false);
      setObservingIds([]);
      setSelectedRows([]);
      setShowRadioButtons(false);
      
      await loadTableData();
      
    } catch (error) {
      console.error('Error al enviar observación:', error);
      
      let errorMessage = 'Error al enviar la observación.';
      
      if (error.response) {
        const errorData = error.response.data;
        if (errorData.errors && errorData.errors.length > 0) {
          const errorMessages = errorData.errors.join('\n');
          errorMessage = `${errorData.message}\n\nDetalles:\n${errorMessages}`;
        } else {
          errorMessage = errorData.message || 'Error al enviar la observación.';
        }
      } else {
        errorMessage = 'Error de conexión. Por favor, intente nuevamente.';
      }
      
      setObsErrorModalMessage(errorMessage);
      setShowObsErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

const closeObsSuccessModal = () => {
  setShowObsSuccessModal(false);
  setObsModalMessage('');
};

const closeObsErrorModal = () => {
  setShowObsErrorModal(false);
  setObsErrorModalMessage('');
};

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="pt-4 md:pt-8 pb-10 px-[3%]">
          <div className="flex flex-col justify-between w-full gap-2 pb-6 items-left sm:items-center lg:flex-row">
            <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">Mis Actas de Trabajo Culminado</h1>
            <div className="flex flex-col items-center justify-between gap-3 sm:flex-row sm:gap-3">
              <div className="flex items-end md:items-center">
                <FilterInput
                  placeholder="Buscar ATC"
                  value={searchTerm}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                      if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                        handleSearchChange(inputValue)
                      }
                  }}
                  classname=" sm:w-auto md:w-full"
                />
              </div>
              <div className="flex items-center gap-3">
                <ATCFilters 
                  onDateRangeChange={({ startDate, endDate }) => {
                    setTempFilters(prev => ({
                      ...prev,
                      emissionDateFrom: startDate,
                      emissionDateTo: endDate
                    }));
                  }}
                  onFilterChange={handleFilterChange}
                  applyFilters={applyFilters}
                  activeFilters={activeFilters}
                  resetFlag={resetFiltersFlag}
                  supplierId={supplierId}
                />
                <ResetFilters
                  borderColor="border-blue-light"
                  textColor="text-[#6B7280]"
                  font="font-itcbook"
                  onClick={handleResetFilters}
                />
              </div>
            </div>
          </div>
          
          <div className="flex flex-col items-end justify-between gap-4 md:items-center lg:flex-row ">
            <div className="flex flex-col w-full overflow-x-auto scrollbar-hide"> 
              <nav className="flex ">  
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    className={`px-5 border-b-[3px] border-blue  h-[54px] md:h-[64px]  font-itcmedium rounded-t-xl flex items-center justify-between gap-2 flex-shrink-0 whitespace-nowrap 
                      ${activeTab === tab ? 'text-white bg-blue cursor-default' : 'text-blue bg-white cursor-pointer'}`}
                    onClick={() => handleTabChange(tab)}
                    disabled={activeTab === tab}
                  >
                    <p className="text-sm md:text-lg font-itcmedium">{tab}</p>
                     {/** 
                    {tab !== 'Todas' && tabCounts[tab] > 0 && (
                      <div className="p-1 text-sm px-[9px] inline-block text-white rounded-full font-itcbold  bg-red-dark">
                        {tabCounts[tab]}
                      </div>
                    )}*/}
                      
                  </button>
                ))}
              </nav>
          </div>

            {activeTab === 'Pendiente de llenado de ATC' &&  tableData.length > 0 && (
            <div className="flex ">
              <button
                onClick={handleSelectClick}
                className={`text-white font-itcmedium rounded-lg p-2 px-4 flex-shrink-0 ${showRadioButtons ? 'bg-blue' : 'bg-[#58B6E5]'}`}
              >
                Seleccionar
              </button>
            </div>
            )}

          </div>
          
          <div className="flex flex-col-reverse items-start justify-between gap-3 my-4 md:items-center md:flex-row">
            <div className="flex items-center space-x-2 text-sm font-itcbook">
              <p >Mostrar</p>
              <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                <select
                  className="w-full h-full px-2 text-sm bg-white rounded-md outline-none font-itcbook"
                  value={recordsPerPage}
                  onChange={handleRecordsCountChange}  
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
              </div>
              <p >Registros</p>
            </div>
          </div>
            
          <DynamicTable 
            data={tableData} 
            config={getTableConfig(activeTab)} 
            showRadioButtons={showRadioButtons}
            selectedRows={selectedRows}
            onCheckboxChange={handleCheckboxChange}
            currentPage={currentPage}
            totalPages={totalPages}
            changePage={changePage}
            recordsPerPage={recordsPerPage}
            totalRecords={totalRecords}
            statusColors={statusColors}
            liberationStatusColors={liberationStatusColors}
            generalStatusColors={generalStatusColors}
            loading={loading || isTabChanging}
            isOCProvider={activeTab !== 'Todas'}
            onSelectAll={(selectAll) => {
              if (selectAll) {
                const pageIds = tableData.map(item => item.id);
                setSelectedRows(pageIds);
              } else {
                setSelectedRows([]);
              }
            }}
            allSelected={selectedRows.length === tableData.length && tableData.length > 0}

          />    

            {activeTab === 'Pendiente de llenado de ATC' && tableData.length > 0 && (
              <>
              <div>
                <div className={`fixed fz-10  transform -translate-x-1/2 bottom-4 left-1/2 
                      ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
                    <button
                      onClick={handleObs}
                      disabled={selectedRows.length === 0}
                      className={`p-3 w-[120px] text-lg flex items-center justify-center h-[50px] text-white rounded-md  font-itcmedium
                        ${selectedRows.length > 0 
                      ? "bg-red cursor-pointer " 
                      : "bg-gray cursor-not-allowed"}
                      `}>
                      Observar
                    </button>

                </div>
              </div>
              </>
            )}     
        </div>
      </div>
      
      <DetailATC 
        isOpen={isDetailModalOpen}
        onClose={handleCloseDetails}
        atcData={selectedATC}
      />

      <AtcObs
        isOpen={isObsModalOpen}
        onClose={() => setIsObsModalOpen(false)}
        onSubmit={handleObsSubmit}
      />

      <ModalSuccess
        showModalSuccess={showObsSuccessModal}
        closeModalSuccess={closeObsSuccessModal}
        text={obsModalMessage}

      />

      <ModalAlertWarning
        showModalAlertWarning={showObsErrorModal}
        closeModal={closeObsErrorModal}
        error={obsErrorModalMessage}
        accept={closeObsErrorModal}
      />

    </div>
  );
}